import React, { memo } from 'react'

import Checkbox from 'components/CommonUI/Checkbox'
import RadioButton from 'components/CommonUI/RadioButton/RadioButton'
import SortArrowDownIcon from 'components/CommonUI/svgIcons/SortArrowDownIcon'

import { sortDirectionConstant, selectComponentTypes } from 'constants/tableConstants'
import { equal } from 'utils/memoEqual'

const Cell = (props) => {
  const {
    className = '',
    value = '',
    isHeader = false,
    isSelectAction = false,
    data = {},
    valuesStringType = '',
    valuesType = '',
    percentValue = '',
    cellRender,
    isSort = false,
    onClickSort,
    dataField = '',
    sortedField = '',
    direction = '',
    selectComponent,
    align = 'left',
    width = 'auto',
  } = props

  if (isHeader) {
    return (
      <HeaderCell
        isSort={isSort}
        dataField={dataField}
        direction={direction}
        onClickSort={onClickSort}
        sortedField={sortedField}
        className={className}
        align={align}
        value={value}
        width={width}
      />
    )
  }
  return (
    <BodyCell
      data={data}
      selectComponent={selectComponent}
      className={className}
      align={align}
      isSelectAction={isSelectAction}
      cellRender={cellRender}
      value={value}
      valuesStringType={valuesStringType}
      valuesType={valuesType}
      percentValue={percentValue}
      width={width}
    />
  )
}

const HeaderCell = memo(
  ({
    isSort,
    dataField,
    direction,
    onClickSort,
    sortedField,
    className,
    align,
    value,
    width,
  }) => {
    const handleClickSort = () => {
      onClickSort(
        dataField,
        direction === sortDirectionConstant.ASC
          ? sortDirectionConstant.DESC
          : sortDirectionConstant.ASC
      )
    }

    const classNameIcon = sortedField === dataField ? direction : ''
    const classNameSorted = sortedField === dataField ? 'sorted' : ''

    const _renderValue = <span>{value}</span>

    return (
      <th
        className={`table_cell table_cell_header ${className}`}
        align={align}
        width={width}
      >
        {isSort ? (
          <button onClick={handleClickSort}>
            {_renderValue}
            <SortArrowDownIcon
              className={`sort_icon ${classNameIcon} ${classNameSorted}`}
            />
          </button>
        ) : (
          <span>{_renderValue}</span>
        )}
      </th>
    )
  }
)

const BodyCell = memo((props) => {
  const {
    data,
    selectComponent,
    className,
    align,
    isSelectAction,
    cellRender,
    value,
    valuesStringType,
    valuesType,
    percentValue,
    width,
  } = props

  const isCheckbox = selectComponent === selectComponentTypes.checkbox

  const ControlCompoment = isCheckbox ? Checkbox : RadioButton

  return (
    <td className={`table_cell ${className}`} align={align} width={width}>
      <span>
        {isSelectAction && (
          <ControlCompoment
            checked={!!data?.checked}
            color={data.controlColor}
            className="table_cell_checkbox"
            dataId={data.id}
          />
        )}
        {cellRender ? (
          cellRender({ data })
        ) : (
          <>
            {value}
            {!!valuesStringType && (
              <span className={`${valuesType}`}>&nbsp;{valuesStringType}</span>
            )}
            {!!percentValue && (
              <span className={'substring'}>&nbsp;{percentValue}</span>
            )}
          </>
        )}
      </span>
    </td>
  )
}, equal)

export default memo(Cell, equal)
